import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d3d40d6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LinePointMarker = _resolveComponent("LinePointMarker")
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-shape", { 'lock': _ctx.elementInfo.lock }],
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
    }
  }, [
    _createVNode("div", {
      class: "element-content",
      style: { filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '' }
    }, [
      _createVNode(_component_SvgWrapper, {
        overflow: "visible",
        width: _ctx.svgWidth,
        height: _ctx.svgHeight
      }, {
        default: _withId(() => [
          _createVNode("defs", null, [
            (_ctx.elementInfo.points[0])
              ? (_openBlock(), _createBlock(_component_LinePointMarker, {
                  key: 0,
                  id: _ctx.elementInfo.id,
                  position: "start",
                  type: _ctx.elementInfo.points[0],
                  color: _ctx.elementInfo.color,
                  baseSize: _ctx.elementInfo.width
                }, null, 8, ["id", "type", "color", "baseSize"]))
              : _createCommentVNode("", true),
            (_ctx.elementInfo.points[1])
              ? (_openBlock(), _createBlock(_component_LinePointMarker, {
                  key: 1,
                  id: _ctx.elementInfo.id,
                  position: "end",
                  type: _ctx.elementInfo.points[1],
                  color: _ctx.elementInfo.color,
                  baseSize: _ctx.elementInfo.width
                }, null, 8, ["id", "type", "color", "baseSize"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("path", {
            d: _ctx.path,
            stroke: _ctx.elementInfo.color,
            "stroke-width": _ctx.elementInfo.width,
            "stroke-dasharray": _ctx.lineDashArray,
            fill: "none",
            "stroke-linecap": "",
            "stroke-linejoin": "",
            "stroke-miterlimit": "",
            "marker-start": _ctx.elementInfo.points[0] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[0]}-start)` : '',
            "marker-end": _ctx.elementInfo.points[1] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[1]}-end)` : ''
          }, null, 8, ["d", "stroke", "stroke-width", "stroke-dasharray", "marker-start", "marker-end"]),
          _withDirectives(_createVNode("path", {
            class: "line-path",
            d: _ctx.path,
            stroke: "transparent",
            "stroke-width": "20",
            fill: "none",
            onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleSelectElement($event))
          }, null, 40, ["d"]), [
            [_directive_contextmenu, _ctx.contextmenus]
          ])
        ]),
        _: 1
      }, 8, ["width", "height"])
    ], 4)
  ], 6))
})